import { Pipe, PipeTransform } from '@angular/core';
import { UtilityFlightService } from '../services';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'countryName', pure: false
})
export class CountryNamePipe implements PipeTransform {
  
  private list: any[] = [];

  constructor(s: UtilityFlightService) {
    s.fetchCountryCodeList()
      .pipe(map((d: any) => d || []))
      .subscribe(d => (this.list = d));
  }

  transform(c: string): string {
    return (!c || !this.list.length) ? c : (this.list.find((x: any) => x.id == c)?.name || c);
  }

}
